import { useEffect, useState } from 'react';

// A device is treated as "mobile" (no editing) when the viewport is narrow
// (<768px) OR it is a touch device with a small physical screen (phone, also in
// landscape). Reactive to resize / orientation changes.
function detect() {
  if (typeof window === 'undefined') return false;
  try {
    const narrow = window.matchMedia('(max-width: 767px)').matches;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const shortSide = Math.min(window.screen?.width || 9999, window.screen?.height || 9999);
    return narrow || (coarse && shortSide < 560);
  } catch (e) {
    return window.innerWidth < 768;
  }
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(detect);
  useEffect(() => {
    const update = () => setIsMobile(detect());
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);
  return isMobile;
}
